import { Apis } from "libs/apis";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";

export const useSessionPrerequisites = () => {
  const getSessionPrerequisites = async (
    setData: any,
    setPaginationState: any,
    offset: number = 0,
    limit: number = 10
  ) => {
    try {
      const res = await Apis.getSessionPrerequisites(offset, limit);
      setData(res.data.data || []);
      setPaginationState({
        total: res.data.total || 0,
        offset: offset,
        limit: limit,
      });
    } catch (err: any) {
      if (err.response && err.response.status === 404) {
        setData([]);
        setPaginationState({ total: 0, offset: 0, limit: limit });
      } else {
        console.error(err);
      }
    }
  };

  const getSessionPrerequisiteById = async (id: number, setData: any) => {
    try {
      const res = await Apis.getSessionPrerequisiteById(id);
      setData(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const postSessionPrerequisite = async (body: FormData) => {
    try {
      const res = await Apis.postSessionPrerequisite(body);
      if (res.data.status) {
        dispatch(setModalClosed("Session Prerequisite"));
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const putSessionPrerequisite = async (id: number, body: FormData) => {
    try {
      const res = await Apis.putSessionPrerequisite(id, body);
      if (res.data.status) {
        dispatch(setModalClosed("Session Prerequisite"));
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    getSessionPrerequisites,
    getSessionPrerequisiteById,
    postSessionPrerequisite,
    putSessionPrerequisite,
  };
};

